import React, { Component } from 'react';

class OriginalPictureSize extends Component {
  	render() {
  		const {frameImageHeight, frameImageWidth} = this.props;
	    return (
	       <tr>
				<th>Canvas Size</th>
				<td>{frameImageWidth}cm X {frameImageHeight}cm</td>
				<td></td>
            </tr>
	    );
  	}
}

export default OriginalPictureSize;